









































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";
import RentalProductDetails from "./RentalProductDetails.vue";

import SettingsJson from "../../shared/SettingsJson";
import RentalItemJson from "../../shared/RentalItemJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "RentalProducts",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    RentalProductDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      GeneralInfos: GeneralInfos,
      showDetails: false,
      detailsMode: "read",
      allProducts: null as RentalItemJson[] | null,
      searchString: "",
      selectedProductId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: RentalItemJson | null, mode: string) {
      if (item != null) {
        this.selectedProductId = item.ID;
      } else {
        this.selectedProductId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllProducts();
    },

    async loadAllProducts() {
      this.allProducts = null;
      this.selectedProductId = null;

      if (this.restClient != null) {
        try {
          this.allProducts = await this.restClient.getRentalItems();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadAllProducts();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    productColumns: function (): TableViewColumnDefinitions<RentalItemJson>[] {
      let vue = this;

      return [
        {
          th: "Bezeichnung",
          td: (i) => i.name,
        },
        {
          th: "Kategorie",
          td: (i) => i.category,
        },
        {
          th: "Stückzahl",
          td: (i) => i.amount,
        },
        {
          th: "Beschränkt auf",
          td: "",
          categoryLabel: (i) => i.restrictToTypes ?? [],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<RentalItemJson>[];
    },

    filteredAllProducts(): RentalItemJson[] | undefined {
      if (this.allProducts != null) {
        var products: RentalItemJson[] = this.allProducts as RentalItemJson[];

        //search
        var tokens = this.searchString
          .split(" ")
          .map((t) => t.trim().toLowerCase())
          .filter((t) => t.length > 0);

        for (var token of tokens) {
          products = products.filter(
            (i) => i.name.toLowerCase().includes(token) || i.category.toLowerCase().includes(token)
          );
        }

        return products;
      }
    },

    allUsedCategories(): string[] {
      let categories: string[] = [];

      if (this.allProducts != null) {
        for (let i of this.allProducts) {
          if (categories.indexOf(i.category) <= 0) {
            categories.push(i.category);
          }
        }
      }

      return [...new Set(categories)];
    },
  },
});
